var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCountlessCoffee(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 196.947,
    height: 189.5,
    viewBox: "0 0 196.947 189.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4cb8b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0099d6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3544",
    "data-name": "Rectangle 3544",
    width: 55.285,
    height: 70.568,
    fill: "#f8f9fa"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27704",
    "data-name": "Group 27704",
    transform: "translate(-4325 -795.079)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27316",
    "data-name": "Group 27316",
    transform: "translate(-283.053 10.254)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53025",
    "data-name": "Path 53025",
    d: "M0,53.992v92.3a43.2,43.2,0,0,0,43.2,43.2H153.744a43.2,43.2,0,0,0,43.2-43.2V43.207a43.2,43.2,0,0,0-47.4-43L39.007,10.994A43.2,43.2,0,0,0,0,53.992",
    transform: "translate(4608.053 784.825)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27255",
    "data-name": "Group 27255",
    transform: "translate(4678.884 806.466)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27254",
    "data-name": "Group 27254",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52997",
    "data-name": "Path 52997",
    d: "M.059,128.05l4,14.729,3.985,14.675,2.25,8.285a1.666,1.666,0,0,0,.6.876,1.548,1.548,0,0,0,1.022.362q5.614-.628,11.261-.874,5.616-.244,11.239-.106,3.2.079,6.393.281a1.687,1.687,0,0,0,1.193-.494,1.88,1.88,0,0,0,.494-1.193q.237-2.958.63-5.9-.03.224-.06.448a111.942,111.942,0,0,1,5.439-22.524q1.1-3.091,2.372-6.113l-.17.4q.547-1.294,1.126-2.575a1.687,1.687,0,0,0-1.456-2.538q-9.331-1.019-18.723-1.3-9.327-.277-18.656.181-5.27.259-10.525.752a1.816,1.816,0,0,0-1.193.494A1.687,1.687,0,0,0,2.479,128.8q9.346-.876,18.74-1.013,9.33-.134,18.651.466,5.265.339,10.512.913l-1.456-2.538a114.979,114.979,0,0,0-5.412,14.434,111.925,111.925,0,0,0-3.336,14.709q-.688,4.388-1.05,8.82l1.687-1.687q-5.638-.356-11.29-.329-5.621.028-11.231.438-3.192.233-6.372.59l1.626,1.238-4-14.729L5.562,135.438l-2.25-8.285a1.707,1.707,0,0,0-2.075-1.178A1.718,1.718,0,0,0,.059,128.05",
    transform: "translate(0 -96.415)",
    fill: "#f8f9fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52998",
    "data-name": "Path 52998",
    d: "M194.01,183.3c.069-.033.137-.065.207-.1l-.4.17a4.04,4.04,0,0,1,.947-.258l-.448.06a4.411,4.411,0,0,1,1.134,0l-.448-.06a4.594,4.594,0,0,1,1.1.3l-.4-.17a4.4,4.4,0,0,1,.6.317c.137.087.444.376.027,0,.084.076.173.146.254.226s.157.163.234.248c.154.17-.114-.16-.121-.164.045.023.088.123.115.163a4.678,4.678,0,0,1,.417.786l-.17-.4a7.676,7.676,0,0,1,.457,1.833q-.03-.224-.06-.448a25.046,25.046,0,0,1,.175,3.018,24.677,24.677,0,0,1-.066,3.009q.03-.224.06-.448a3.667,3.667,0,0,1-.246.944l.17-.4a3.153,3.153,0,0,1-.2.376c-.075.118-.257.292.066-.065-.038.042-.072.088-.11.13a3.932,3.932,0,0,1-.3.3c-.009.008-.191.174-.2.168s.373-.276.1-.08a8.74,8.74,0,0,1-1.651.882l.4-.17a14.428,14.428,0,0,1-3.575.98l.448-.06a8.946,8.946,0,0,1-2.163.113l.448.06a1.652,1.652,0,0,1-.341-.092l.4.17c-.075-.035-.241-.156,0,.033a.6.6,0,0,1,.217.219q.147.219.07.074l.17.4-.016-.055q.03.224.06.448a.366.366,0,0,1,0-.123,1.7,1.7,0,0,0-1.687-1.687A1.724,1.724,0,0,0,188,195.648a2.189,2.189,0,0,0,1.573,2.085,4.112,4.112,0,0,0,1.616.156,16.245,16.245,0,0,0,3.405-.5,15.407,15.407,0,0,0,3.142-1.194,6.508,6.508,0,0,0,2.474-2.116,6.152,6.152,0,0,0,.781-3.45c.013-1.091.025-2.184-.031-3.274-.11-2.14-.418-4.572-2.132-6.073a5.916,5.916,0,0,0-6.516-.9,1.7,1.7,0,0,0-.6,2.308,1.73,1.73,0,0,0,2.308.605",
    transform: "translate(-145.714 -139.356)",
    fill: "#f8f9fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52999",
    "data-name": "Path 52999",
    d: "M10.949,168.12l18.979-.586,5.391-.166a1.687,1.687,0,0,0,0-3.373l-18.979.586-5.391.166a1.687,1.687,0,1,0,0,3.373",
    transform: "translate(-7.178 -127.112)",
    fill: "#f8f9fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53000",
    "data-name": "Path 53000",
    d: "M86.794,21.532a8.932,8.932,0,0,1-.982-.611l-.143-.106.2.155a2.346,2.346,0,0,1-.24-.2q-.219-.188-.424-.392c-.125-.125-.246-.255-.361-.39-.039-.045-.286-.356-.091-.1s-.042-.066-.076-.115a6.043,6.043,0,0,1-.558-1.018l.17.4a5.722,5.722,0,0,1-.368-1.338q.03.224.06.448a5.31,5.31,0,0,1,0-1.38l-.06.448a4.754,4.754,0,0,1,.285-1.061l-.17.4a4.757,4.757,0,0,1,.394-.74c.069-.105.142-.207.215-.31.159-.223-.081.1-.092.116.051-.077.119-.15.177-.222.418-.515.852-1.02,1.226-1.569A9.74,9.74,0,0,0,87.386,10.6a10.188,10.188,0,0,0-1.081-7.259,10.571,10.571,0,0,0-2.8-3.12,1.69,1.69,0,0,0-1.3-.17A1.721,1.721,0,0,0,81.2.831a1.7,1.7,0,0,0-.17,1.3,2,2,0,0,0,.775,1.008c-.451-.348.03.036.135.13q.2.176.384.365t.36.389q.087.1.171.2c.089.109.2.338-.046-.063.183.3.405.578.582.886A8.954,8.954,0,0,1,83.861,6l-.17-.4a8.609,8.609,0,0,1,.575,2.131l-.06-.448a8.685,8.685,0,0,1,0,2.142l.06-.448a8.911,8.911,0,0,1-.611,2.247l.17-.4a8.639,8.639,0,0,1-.652,1.238q-.1.157-.208.31c-.039.055-.274.367-.093.131s-.056.067-.1.126c-.08.1-.161.2-.241.293a7.879,7.879,0,0,0-1.76,3.028,7.184,7.184,0,0,0,1.7,6.433,9.274,9.274,0,0,0,2.633,2.07,1.687,1.687,0,1,0,1.7-2.913",
    transform: "translate(-62.444 0.001)",
    fill: "#f8f9fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53001",
    "data-name": "Path 53001",
    d: "M135.292,56.953c-.185-.2-.369-.409-.549-.618q-.151-.176-.3-.356a.867.867,0,0,1-.116-.145c.047.1.23.3.066.084a7.33,7.33,0,0,1-.857-1.442l.17.4a4.525,4.525,0,0,1-.309-1.1q.03.224.06.448a3.849,3.849,0,0,1,0-.937q-.03.224-.06.448a5.637,5.637,0,0,1,.4-1.369l-.17.4c.388-.906.878-1.761,1.251-2.675a5.4,5.4,0,0,0,.317-3.14,1.7,1.7,0,0,0-2.075-1.178,1.729,1.729,0,0,0-1.178,2.075c.015.077.028.153.04.231q-.03-.224-.06-.448a3.343,3.343,0,0,1-.011.832l.06-.448a5.394,5.394,0,0,1-.376,1.253l.17-.4c-.7,1.636-1.794,3.186-1.71,5.048.1,2.169,1.449,3.878,2.847,5.419a1.7,1.7,0,0,0,2.385,0,1.725,1.725,0,0,0,0-2.385",
    transform: "translate(-100.806 -35.434)",
    fill: "#f8f9fa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_27315",
    "data-name": "Group 27315",
    transform: "translate(3873.527 625.938)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "countless",
    transform: "translate(833 293.135)",
    fill: "#f8f9fa",
    fontSize: 36,
    fontFamily: "Helvetica-Bold, Helvetica",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -84.023,
    y: 0
  }, "countless")), /*#__PURE__*/React.createElement("text", {
    id: "cups_of_coffee",
    "data-name": "cups of coffee",
    transform: "translate(784.5 313.408)",
    fill: "#f8f9fa",
    fontSize: 15,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "cups of coffee")))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountlessCoffee);
export default __webpack_public_path__ + "static/media/countless-coffee.31a5a0b999d3ca0a7ff2dc85de6e4752.svg";
export { ForwardRef as ReactComponent };